import styled from "styled-components";

const Office = styled.div`
    position: relative;
    transition: transform 420ms cubic-bezier(.165,.84,.44,1);

    p {
        a {
            border-bottom: 1px solid #23A14B;
            transition-duration: .2s;
            -webkit-transition-duration: all 0.2s ease-in-out;
            -moz-transition-duration: all 0.2s ease-in-out;
            -o-transition-duration: all 0.2s ease-in-out;
            -ms-transition-duration: all 0.2s ease-in-out;
            transition: all 0.2s ease-in-out;

            &:hover {
                border-bottom: 1px solid #9c9c9c;
            }
        }
    }
`;

const OfficeInfo = styled.div`
    img {
        height: 13rem;
        width: 100%;
        object-fit: cover;
    }
`;

const OfficeHeight = styled.div`
    min-height: 23.5rem;
`;

const OfficeGrid = styled.div`
    grid-template-columns: 2.3fr 8fr;
`;

const Associates = styled.a`
    &:after {
         content: "",
    }
`;

const OfficeMini = styled.div`
    content: '•';
    margin: 0 .36rem;
`;

const S = {
    Office,
    OfficeInfo,
    OfficeHeight,
    OfficeGrid,
    Associates,
    OfficeMini
};

export default S;
